function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import GridParagraphWithImage from "segments/desktop/core-components/grid-paragraph-with-image/grid-paragraph-with-image";
import classnames from "classnames";
import Constants from "segments/desktop/header/layouts/components/basic-header/constants";
import { StyledFlexibleCardsGridDesktopComponent } from "./flexible-cards-grid-desktop-component.scss";
import FlexibleCardsGridDefaultProps from "../default-props";
import { COLUMN_WIDTH, MARGIN_BETWEEN_CARDS } from "../../flexible-cards-consts";
import { generateOnKeyDownHandler } from "/client/services/accessibility/accessibility-service";
import { trackEvent } from "/services/bigbrain-service";
import { FLEXIBLE_GRID_CARD_HOVERED } from "/constants/bigbrain-event-types";
const IMAGE_HEIGHT = "100%";
const IMAGE_WIDTH = "100%";
const margin = `${MARGIN_BETWEEN_CARDS / 2}px`;
const FlexibleCardsGridDesktopComponent = (props)=>{
    const renderGridItems = ()=>{
        const { shadowCards, removeShadowOnHover, gridItems, titleSize, textSize, topicBottomMargin, spaceFromParagraph, buttonTopMargin, innerPadding, defaultCardClick, borderColor } = props;
        return gridItems.map((gridItem, index)=>{
            const { textColor, cardColor, backgroundImage, cardNumOfColumnsWidth, fullParagraph, addBackLayerContent, cardBackLayerContent, cardTagText, cardTagColor, paragraphVerticalColoredLineColor, onCardClick } = gridItem, resImageProps = _object_without_properties(gridItem, [
                "textColor",
                "cardColor",
                "backgroundImage",
                "cardNumOfColumnsWidth",
                "fullParagraph",
                "addBackLayerContent",
                "cardBackLayerContent",
                "cardTagText",
                "cardTagColor",
                "paragraphVerticalColoredLineColor",
                "onCardClick"
            ]);
            const flexibleCardHovered = ()=>{
                trackEvent(FLEXIBLE_GRID_CARD_HOVERED, {
                    kind: (fullParagraph === null || fullParagraph === void 0 ? void 0 : fullParagraph.title) || (fullParagraph === null || fullParagraph === void 0 ? void 0 : fullParagraph.body)
                });
            };
            const columnWidthForCss = `${COLUMN_WIDTH}px`;
            let cardWidthForCss;
            if (cardNumOfColumnsWidth) {
                const cardWidth = cardNumOfColumnsWidth * COLUMN_WIDTH + (cardNumOfColumnsWidth - 1) * MARGIN_BETWEEN_CARDS;
                cardWidthForCss = `${cardWidth}px`;
            }
            const onClickCallBack = onCardClick || defaultCardClick;
            const isCardClickable = onClickCallBack;
            const onKeyDown = isCardClickable ? generateOnKeyDownHandler(onClickCallBack) : null;
            const cardAccesibilityProps = isCardClickable ? {
                onKeyDown,
                tabIndex: 0
            } : {};
            const layersSharedProps = {
                topicBottomMargin,
                spaceFromParagraph,
                buttonTopMargin
            };
            const fullParagraphFullProps = _object_spread({}, layersSharedProps, fullParagraph);
            const backLayerparagraphProps = _object_spread({}, layersSharedProps, cardBackLayerContent === null || cardBackLayerContent === void 0 ? void 0 : cardBackLayerContent.backLayerFullParagraph);
            return /*#__PURE__*/ _jsxs("div", _object_spread_props(_object_spread({
                className: classnames("grid-paragraph-with-image-component-wrapper", {
                    "has-background-paragraph": addBackLayerContent
                }),
                style: {
                    "--flexible-grid-card-width": cardWidthForCss || columnWidthForCss,
                    "--cards-margin": margin
                },
                onClick: onClickCallBack
            }, cardAccesibilityProps), {
                role: "listitem",
                onMouseEnter: flexibleCardHovered,
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "top-layer",
                        children: /*#__PURE__*/ _jsx(GridParagraphWithImage, _object_spread_props(_object_spread({}, resImageProps), {
                            borderColor: borderColor,
                            fullParagraph: fullParagraphFullProps,
                            width: IMAGE_WIDTH,
                            height: IMAGE_HEIGHT,
                            titleSize: titleSize,
                            textSize: textSize,
                            cardColor: cardColor,
                            textColor: textColor,
                            shadowCards: shadowCards,
                            removeShadowOnHover: removeShadowOnHover,
                            cardWidthForCss: cardWidthForCss,
                            backgroundImage: backgroundImage,
                            cardTagText: cardTagText,
                            cardTagColor: cardTagColor,
                            paragraphVerticalColoredLineColor: paragraphVerticalColoredLineColor,
                            padding: innerPadding
                        }))
                    }),
                    addBackLayerContent && /*#__PURE__*/ _jsx("div", {
                        className: "back-layer",
                        children: /*#__PURE__*/ _jsx(GridParagraphWithImage, {
                            fullParagraph: backLayerparagraphProps,
                            width: IMAGE_WIDTH,
                            height: IMAGE_HEIGHT,
                            titleSize: titleSize,
                            textSize: textSize,
                            cardColor: cardColor,
                            textColor: textColor,
                            shadowCards: shadowCards,
                            borderColor: borderColor,
                            removeShadowOnHover: removeShadowOnHover,
                            cardWidthForCss: cardWidthForCss,
                            contentVerticalAlignment: cardBackLayerContent === null || cardBackLayerContent === void 0 ? void 0 : cardBackLayerContent.contentVerticalAlignment,
                            padding: innerPadding,
                            backgroundImage: cardBackLayerContent === null || cardBackLayerContent === void 0 ? void 0 : cardBackLayerContent.backSideBackgroundImage
                        })
                    })
                ]
            }), index);
        });
    };
    const { gridAlignment } = props;
    const componentWidthWithoutHeaderPadding = `calc(100% - ${Constants.HEADER_CONTENT_HORIZONTAL_PADDING * 2 - MARGIN_BETWEEN_CARDS}px)`;
    return /*#__PURE__*/ _jsx(StyledFlexibleCardsGridDesktopComponent, {
        className: "flexible-cards-grid-desktop-component",
        style: {
            "--component-alignment": gridAlignment
        },
        children: /*#__PURE__*/ _jsx("div", {
            className: "flexible-cards-grid-desktop-component-inner",
            style: {
                width: componentWidthWithoutHeaderPadding
            },
            role: "list",
            children: renderGridItems()
        })
    });
};
FlexibleCardsGridDesktopComponent.defaultProps = FlexibleCardsGridDefaultProps;
export default FlexibleCardsGridDesktopComponent;
